module.exports = __webpack_public_path__ + "assets/img/img95.7d34884f.png";